<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-button type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
      </el-button>
    </el-col>

    <el-col :xs="24" :sm="24" :lg="24" style="padding: 20px 10px 20px 30px;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本資料" name="basicInfo">
          
          <!-- 基本資料 -->
          <el-card class="box-card">
             <el-form label-position="top"
              :model="form"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
              <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <el-form-item label="商品系列"">
                    <el-select v-model="form.category" placeholder="選擇商品系列">
                      <el-option v-for="cat in categories"
                                 :key="cat.id"
                                 :label="cat.value"
                                 :value="cat.value"></el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="商品名稱" prop="name">
                      <el-input v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="商品型號" prop="model">
                      <el-input v-model="form.model" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="顏色" prop="color">
                      <el-input v-model="form.color" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="價格" prop="price">
                      <el-input v-model="form.price" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="備註" prop="notes">
                      <el-input v-model="form.notes" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="text-right">
              <el-button type="primary" @click="saveData('dataForm')">儲存修改</el-button>
            </div>
          </el-card>
          <!-- end 基本資料 -->

          <!-- 修改紀錄 -->
          <el-card class="mt-20">
            <div slot="header" class="clearfix">
              <span class="mr-20">產品資料修改紀錄</span>
            </div>
            <el-table :data="history.gridData" empty-text="目前尚無資料">
              <el-table-column property="createdAt" label="日期">
              </el-table-column>
              <el-table-column property="user.username" label="更新人員"></el-table-column>
              <el-table-column width="300" label="備註">
                <template slot-scope="scope">
                  <div v-html="scope.row.notes"></div>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="history.pageNum"
                  :page-size="history.pageSize"
                  :total="history.total"
                  @current-change="handleHistoryTableChange">
              </el-pagination>
            </div>
          </el-card>
          <!-- end 修改紀錄 -->

        </el-tab-pane>

      </el-tabs>
    </el-col>
    


  </el-row>


</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import dayjs from "dayjs"


export default {
  name: "ProductDetail",
  components: {
    Breadcrumb
  },
  data() {
    let fieldRequired = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      activeName: 'basicInfo',

      /**上頁接收的參數**/
      pid:'',

      /**客戶修改紀錄**/
      history: {
        gridData: [],
        pageNum: 0,
        pageSize: 10,
        total: 0
      },

      /**基本資料表單**/
      form: {
        id:'',
        name: '',
        model: '',
        color: '',
        price: '',
        category: ''
      },

      categories:[],
      
      rules: {
        name: [{required: true, validator: fieldRequired, trigger: 'change'}],
        model: [{required: true, validator: fieldRequired, trigger: 'change'}],
        price: [{required: true, validator: fieldRequired, trigger: 'change'}]
      }
    }
  },
  methods: {
    
    saveData(formName) {
      this.$refs[formName].validate(async valid => {

        if (valid) {

          this.request.post("/product", this.form).then(res => {
            if (res.code === '200') {
              this.getProductInfo()
              this.getProductUpdateHistory()
              this.showResult('success', '資料更新成功.')
            } else {
              this.showResult('success', '資料更新失敗')
            }
          })

        }
      })
    },
    getProductInfo() {
      this.request.get("/product/" + this.pid).then(res => {
        if (res.code === '200') {
          this.form = res.data
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    goBack(){
      this.$router.push('/products/maintain')
    },

    handleHistoryTableChange(val) {
      this.history.pageNum = val
      this.getProductUpdateHistory()
    },

    getProductUpdateHistory() {
      try {
        let {pageNum, pageSize} = this.history
        this.request.get(`/product/history?pid=${this.pid}`).then(res => {
          if (res.code === '200') {
            this.history.gridData = res.data
          }
        })
      } catch (e) {
        this.showResult('error', e.message)
      }
    },
    prepareProductCategory() {
      let req = '/dic/type?queryField=product_cat'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.categories = res.data
          this.getProductInfo()
        }
      })
    }
  },
  mounted() {
    
    this.pid = this.$route.params.pid

    
    this.prepareProductCategory()
    this.getProductUpdateHistory()

    
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.start_import {
  display: block;
}

.stop_import {
  display: none;
}


</style>
